import ApiClient from './ApiClient';

const apiClient = ApiClient('/devices');

export const createLoadCell = (craneId, payload, onSuccess, onError, onDone) => {
    apiClient.post(`/${craneId}/load_cell/`, payload).then(onSuccess).catch(onError).finally(onDone);
};

export const updateLoadCell = (craneId, loadCellId, payload, onSuccess, onError, onDone) => {
    apiClient.put(`/${craneId}/load_cell/${loadCellId}/`, payload).then(onSuccess).catch(onError).finally(onDone);
};

export const upsertLoadCell = (craneId, payload, onSuccess, onError, onDone) => {
    const loadCellId = payload.id;
    delete payload.id;
    if (loadCellId) updateLoadCell(craneId, loadCellId, payload, onSuccess, onError, onDone);
    else createLoadCell(craneId, payload, onSuccess, onError, onDone);
};

export const deleteLoadCell = (craneId, loadCellId, onSuccess, onError, onDone) => {
    apiClient.delete(`/${craneId}/load_cell/${loadCellId}/`).then(onSuccess).catch(onError).finally(onDone);
};

export const createVfd = (craneId, payload, onSuccess, onError, onDone) => {
    apiClient.post(`/${craneId}/vfd/`, payload).then(onSuccess).catch(onError).finally(onDone);
};

export const updateVfd = (craneId, vfdId, payload, onSuccess, onError, onDone) => {
    apiClient.put(`/${craneId}/vfd/${vfdId}/`, payload).then(onSuccess).catch(onError).finally(onDone);
};

export const upsertVfd = (craneId, payload, onSuccess, onError, onDone) => {
    const vfdId = payload.id;
    delete payload.id;
    if (vfdId) updateVfd(craneId, vfdId, payload, onSuccess, onError, onDone);
    else createVfd(craneId, payload, onSuccess, onError, onDone);
};

export const deleteVfd = (craneId, vfdId, onSuccess, onError, onDone) => {
    apiClient.delete(`/${craneId}/vfd/${vfdId}/`).then(onSuccess).catch(onError).finally(onDone);
};

export const getVfdManufacturersList = (onSuccess, onError, onDone) => {
    const url = "/manufacturers/";
    apiClient.get(url).then(onSuccess).catch(onError).finally(onDone);
};

export const getVfdClassesList = (manufacturer_id, onSuccess, onError, onDone) => {
    const url = `/manufacturers/${manufacturer_id}/classes/`;
    apiClient.get(url).then(onSuccess).catch(onError).finally(onDone);
};
